module.exports = __webpack_public_path__ + "static/about-investition1-2548f5e6b66af43864584779a11201b7.jpg";